/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Immediately_Suspend_All_Public_AInputs */

const en_immediately_suspend_all_public_a = /** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immediately suspend all public access to your storefront. Your listings remain active but the storefront is hidden.`)
};

const id_immediately_suspend_all_public_a = /** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segera tangguhkan semua akses publik ke etalase Anda. Listing Anda tetap aktif tetapi etalase Anda disembunyikan.`)
};

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const es_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const fr_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const de_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const ja_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const zh_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const ar_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const it_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const ru_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const pt_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/** @type {(inputs: Immediately_Suspend_All_Public_AInputs) => LocalizedString} */
const ko_immediately_suspend_all_public_a = en_immediately_suspend_all_public_a;

/**
* | output |
* | --- |
* | "Immediately suspend all public access to your storefront. Your listings remain active but the storefront is hidden." |
*
* @param {Immediately_Suspend_All_Public_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const immediately_suspend_all_public_a = /** @type {((inputs?: Immediately_Suspend_All_Public_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Immediately_Suspend_All_Public_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_immediately_suspend_all_public_a(inputs)
	if (locale === "es") return es_immediately_suspend_all_public_a(inputs)
	if (locale === "fr") return fr_immediately_suspend_all_public_a(inputs)
	if (locale === "de") return de_immediately_suspend_all_public_a(inputs)
	if (locale === "ja") return ja_immediately_suspend_all_public_a(inputs)
	if (locale === "zh") return zh_immediately_suspend_all_public_a(inputs)
	if (locale === "ar") return ar_immediately_suspend_all_public_a(inputs)
	if (locale === "id") return id_immediately_suspend_all_public_a(inputs)
	if (locale === "it") return it_immediately_suspend_all_public_a(inputs)
	if (locale === "ru") return ru_immediately_suspend_all_public_a(inputs)
	if (locale === "pt") return pt_immediately_suspend_all_public_a(inputs)
	return ko_immediately_suspend_all_public_a(inputs)
});